<template>
  <div>
    <div class="desktop">
      <div class="reload">
        Обновите страницу
      </div>
    </div>
    <div class="welcoming">
      <loader></loader>

      <div id="container"></div>

      <div class="shadow"></div>

      <img
        class="logo-icon"
        src="../assets/greysislogoicon.svg"
        alt="Logo Icon"
      />
      <br />
      <img
        class="logo-text"
        src="../assets/greysislogotext.svg"
        alt="Logo Text"
      />

      <h3>
        Интеллектуальные системы <br />
        цифровой экономики будущего
      </h3>

      <a class="enter angle active">Войти</a>

      <!-- <social-media></social-media> -->
      <music></music>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import $ from "jquery";
import { TimelineMax } from "gsap/all";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import music from "../components/audio.vue";
import socialMedia from "../components/social-media.vue";
import loader from "../components/loader.vue";

export default {
  name: "welcoming",
  data() {
    return {
      cube: null,
      renderer: null,
      scene: null,
      camera: null,
      v: 0,
    };
  },
  components: {
    music,
    socialMedia,
    loader,
  },
  methods: {
    init: function() {
      this.scene = new THREE.Scene();
      this.scene.transparent = true;
      this.camera = new THREE.PerspectiveCamera(
        55,
        window.innerWidth / window.innerHeight,
        0.1,
        2000
      );

      window.addEventListener("resize", onWindowResize, false);
      function onWindowResize() {
        load.camera.aspect = window.innerWidth / window.innerHeight;
        load.camera.updateProjectionMatrix();
        load.renderer.setSize(window.innerWidth, window.innerHeight);
      }

      var geometry = new THREE.BoxGeometry(3, 3, 70);
      var material = new THREE.MeshBasicMaterial({
        color: 0x2778f3,
        opacity: 0.5,
        transparent: true,
      });

      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setSize(window.innerWidth, window.innerHeight - 5);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      document
        .getElementById("container")
        .appendChild(this.renderer.domElement);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      const loader1 = new FBXLoader();
      let load = this;
      var paceN;
      loader1.load(
        "intro.fbx",
        function(object) {
          for (var tun = 0; tun < 14; tun++) {
            object.children[1].children[
              tun
            ].children[0].material = new THREE.MeshBasicMaterial({
              color: 0xc9c9c9,
              transparent: true,
              opacity: 0.35,
            });
          }
          load.scene.add(object);
        },
        function(xhr) {
          paceN = Math.floor((xhr.loaded / xhr.total) * 100);
          $(".pace-n").html(paceN + "%");
        },
        function(error) {
          console.error(error);
        }
      );

      var tl = new TimelineMax();
      var tk = new TimelineMax();
      var op = new TimelineMax();
      tl.set(this.camera.position, { z: -150 });
      op.set(".shadow, .logo-text, .logo-icon, h3, .enter", { alpha: 0 });
      var meshC = [];
      var i;
      var outside = this;

      var loadering = setInterval(function() {
        if (outside.camera.position.z <= -3000) {
          setTimeout(function() {
            outside.$router.push({ path: "/fulfillment" });
            enableScroll()
          }, 1000);
          clearInterval(loadering);
        }
      }, 500);

      var timer = setInterval(function() {
        if (paceN == 100) {
          $(".pace").fadeOut();
          for (i = 0; i < 500; i++) {
            var mesh = new THREE.Mesh(geometry, material);

            meshC.push(mesh);
            mesh.position.x = (Math.random() - 0.5) * 250;
            mesh.position.y = (Math.random() - 0.5) * 100;

            tk.to(meshC[i].position, 30, { z: -5000 }, i * 0.3);
            outside.scene.add(meshC[i]);
          }

          op.to(".shadow, .logo-text, .logo-icon, h3, .enter", 2, { alpha: 1 });
          clearInterval(timer);
        }
      }, 1000);

      setInterval(function() {
        if (tk.progress() > 0.85) {
          tk.restart();
        }
      }, 700);

      for (i = 0; i < 30; i++) {
        var mesh2 = new THREE.Mesh(geometry, material);
        mesh2.position.x = (Math.random() - 0.5) * 300;
        mesh2.position.y = (Math.random() - 0.5) * 120;
        mesh2.position.z = Math.floor(Math.random() * -2700) + -2100;
        this.scene.add(mesh2);
      }

      var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

      function preventDefault(e) {
        e.preventDefault();
      }

      function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
          preventDefault(e);
          return false;
        }
      }

      // modern Chrome requires { passive: false } when adding event
      var supportsPassive = false;
      try {
        window.addEventListener(
          "test",
          null,
          Object.defineProperty({}, "passive", {
            get: function() {
              supportsPassive = true;
              return supportsPassive;
            },
          })
        );
      } catch (e) {
        console.log("");
      }

      var wheelOpt = supportsPassive ? { passive: false } : false;
      var wheelEvent =
        "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

      function disableScroll() {
        window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
        window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
        window.addEventListener("keydown", preventDefaultForScrollKeys, false);
      }
      function enableScroll() {
        window.removeEventListener("DOMMouseScroll", preventDefault, false);
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
        window.removeEventListener("touchmove", preventDefault, wheelOpt);
        window.removeEventListener(
          "keydown",
          preventDefaultForScrollKeys,
          false
        );
      }

      disableScroll();

      $(".enter").click(function() {
        tl.set(outside.camera.position, { z: -150 });
        tl.to(outside.camera.position, 5, {
          z: -3500,
          ease: "Power1.easeIn",
        });
      });

      this.controls.update();
      this.controls.enabled = false;
    },
    animate: function() {
      requestAnimationFrame(this.animate);
      let me = this;
      if (me.camera.position.z <= -3000) {
        $(".welcoming").fadeOut();
      }
      this.renderer.render(this.scene, this.camera);
    },
  },
  mounted() {
    if (this.$route.name == "welcoming") {
      this.init();
      this.animate();
    }
  },
  destroyed() {
    this.renderer.forceContextLoss();
  },
};
</script>

<style scoped>
.desktop {
  display: block;
}

.welcoming {
  display: none;
}
.reload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.reload a {
  text-decoration: underline;
  opacity: 0.7;
}

@media only screen and (max-width: 900px) {
  .desktop {
    display: none;
  }

  .welcoming {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }

  * {
    overflow: hidden;
  }

  .logo-icon {
    margin-top: 30vh;
    height: 8%;
    margin-bottom: 0px;
    position: relative;
  }

  .logo-text {
    height: 3.5%;
    position: relative;
  }

  br {
    display: block;
    margin: 10px;
  }

  h3 {
    font-weight: normal;
    text-align: center;
    letter-spacing: 0.02em;
    font-size: calc(1vw + 0.9vh + 0.6vmin);
    margin-top: 2vh;
    position: relative;
  }

  .enter {
    text-align: center;
    background-color: #2778f3;
    padding: 8px;
    width: 25vw;
    font-size: calc(1vw + 0.9vh + 0.6vmin);
    color: white;
    text-decoration: none;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 5vh;
    position: relative;
  }

  .angle::before {
    transition: all 4.5s linear;
    opacity: 0;
    display: none;
    width: 0 !important;
  }

  .shadow {
    background-image: url("../assets/shadow.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 70vw;
    height: 70vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  #container {
    position: absolute;
    top: 0;
    overflow: hidden;
    outline: 0;
  }

  canvas:focus,
  #container:focus {
    outline: 0;
  }
}
</style>
